<template>
  <w-icon-wrapper
    :width='24'
    :height='22.5'
    icon-name='nav-icon'
    view-box='0 0 24 22.5'
  >
    <g
      id="Gruppe_27165"
      data-name="Gruppe 27165"
    >
      <path
        id="Pfad_60557"
        data-name="Pfad 60557"
        d="M22,0H2A2.006,2.006,0,0,0,0,2V15a2.006,2.006,0,0,0,2,2H7.89L6.03,20.5H4.13a1,1,0,0,0,0,2h15a1,1,0,0,0,0-2H17.47L15.61,17H22a2.006,2.006,0,0,0,2-2V2a2.006,2.006,0,0,0-2-2M8.3,20.5,10.16,17h3.18l1.86,3.5ZM22,15H2V13.38H22Zm0-3.62H2V2H22Z"
        fill="currentColor"
      />
      <path
        id="Pfad_60558"
        data-name="Pfad 60558"
        d="M9.619,9.531H8.413L6.63,6.4V9.531H5.417V4.5H6.63L8.41,7.63V4.5H9.619Z"
        fill="currentColor"
      />
      <path
        id="Pfad_60559"
        data-name="Pfad 60559"
        d="M13.245,8.591H11.583l-.291.94H10L11.842,4.5h1.14L14.84,9.531h-1.3Zm-1.372-.936h1.082L12.411,5.91Z"
        fill="currentColor"
      />
      <path
        id="Pfad_60560"
        data-name="Pfad 60560"
        d="M16.893,8.163l1-3.663H19.25L17.556,9.531H16.23L14.55,4.5h1.344Z"
        fill="currentColor"
      />
    </g> 
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavNavision' };
</script>